import axios from 'axios';

const CONTEXT_PATH = import.meta.env.VITE_API_CONTEXT_PATH;

export const privateApi = axios.create({
  baseURL: CONTEXT_PATH,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
  // JWT auth is cookie-based; axios must send cookies for cross-site dev/proxy setups.
  withCredentials: true,
});

function getCookieValue(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  // Basic cookie parsing
  const cookies = document.cookie ? document.cookie.split('; ') : [];
  const prefix = `${name}=`;
  const entry = cookies.find((cookie) => cookie.startsWith(prefix));
  if (!entry) {
    return null;
  }
  return decodeURIComponent(entry.substring(prefix.length));
}

export function getRequestConfig(
  offset: number | string,
  max: number | string
) {
  return {
    params: {
      offset,
      max,
    },
  };
}

privateApi.interceptors.request.use((config) => {
  const method = (config.method || 'get').toUpperCase();
  const isUnsafe =
    method === 'POST' ||
    method === 'PUT' ||
    method === 'PATCH' ||
    method === 'DELETE';

  if (isUnsafe) {
    const csrfToken = getCookieValue('XSRF-TOKEN');
    if (csrfToken) {
      const headers = axios.AxiosHeaders.from(config.headers);
      headers.set('X-XSRF-TOKEN', csrfToken);

      return {
        ...config,
        headers,
      };
    }
  }

  return config;
});
